<template>
  <div class="row">
    <div class="col-12">
      <yes-or-no :model="schema.confirmed">
        <span v-html="schema.confirmed.$title" />

        <post-form v-if="attachment" button-class="p-1" icon="fal fa-fw fa-download" :url="downloadLink" />

        <span v-else> [Brak załącznika]</span>
      </yes-or-no>
    </div>

    <div v-if="schema.confirmed.$model" class="col-12 mt-5">
      {{ schema.information.$model }}
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';
import { mapState } from 'vuex';

import PostForm from '@/components/postForm/PostForm';
import YesOrNo from '@/components/forms/document/YesOrNoRadio';
import { config } from '@/utils/config';

// @vuese
// Komponent dla listy BiK
// @group ActionData
export default {
  components: { ...components, YesOrNo, PostForm },
  props: {
    schema: { type: Object, required: false }
  },
  computed: {
    ...mapState({
      attachment: state => state.setting.attachment.list[0]
    }),
    downloadLink() {
      return `${config.mediaURL}/${this.attachment?.mediaId}`;
    }
  },
  mounted() {
    this.schema.confirmed.$setData(null);
  }
};
</script>
